module.exports = __webpack_public_path__ + "img/type--1-spans--single-lang--en.3702537a.jpg";